{
  "version": 1,
  "asset_id": "a4405a86-ab07-41c1-b9ee-0b683aca9193",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a4405a86-ab07-41c1-b9ee-0b683aca9193/band-erosion-egd-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a4405a86-ab07-41c1-b9ee-0b683aca9193/band-erosion-egd-800.jpg",
  "original_filename": "band-erosion-egd-800.jpg",
  "size": 134305,
  "content_type": "image/jpeg",
  "created_at": "2026-11-02T10:46:17Z"
}
